// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__f3ulC","container":"styles_container__7y0OH","title":"styles_title__2Etp0","wrapper":"styles_wrapper__1osaM","answer":"styles_answer__jEzSq"};